import React from 'react';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import { BorderedContentWithTitle } from 'components/WrappedComponents';
import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';
import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { extractNonnullDossierIdOrThrow } from 'utils/dossierUtils';

import { AjoutCommentaire } from './AjoutCommentaire/AjoutCommentaire';
import { DisplayCommentaires } from './DisplayCommentaires/DisplayCommentaires';

import './Commentaires.less';

export const Commentaires = (): React.ReactElement => {
  const user = useUserStore();

  let dossierId: string | undefined;
  if (user.profile === UserDtoProfileEnum.ADMIN_FONCTIONNEL) {
    const [{ result: dossier }] = useDossierAdminContext();
    dossierId = dossier.id;
  } else {
    const [{ result: dossier }] = useDossierContext();
    dossierId = extractNonnullDossierIdOrThrow(dossier);
  }

  return (
    <BorderedContentWithTitle
      className="commentairesContainer"
      title="Commentaires"
    >
      <>
        <AjoutCommentaire dossierId={dossierId} />
        <DisplayCommentaires dossierId={dossierId} />
      </>
    </BorderedContentWithTitle>
  );
};
